/**
 * Language Headers Utility
 * Provides dynamic language headers for API requests
 */

/**
 * Get the current language code from localStorage
 * @returns Language code (e.g., 'it', 'es', 'en')
 */
export const getCurrentLanguageCode = (): string => {
  try {
    // Try to get from i18next storage
    const i18nextLang = localStorage.getItem("i18nextLng");
    if (i18nextLang && i18nextLang !== "null" && i18nextLang !== "undefined") {
      // Normalize language code (remove region: en-US -> en)
      return i18nextLang.split("-")[0].toLowerCase();
    }
  } catch (error) {
    console.warn("Failed to get language from localStorage:", error);
  }
  
  // Default to English
  return "en";
};

/**
 * Get language header object for API requests
 * @returns Object with x-custom-lang header
 */
export const getLanguageHeaders = (): Record<string, string> => {
  const lang = getCurrentLanguageCode();
  return {
    "x-custom-lang": lang
  };
};

/**
 * Merge language headers with existing headers
 * @param existingHeaders - Existing headers object
 * @returns Merged headers with language
 */
export const mergeLanguageHeaders = (existingHeaders: Record<string, string> = {}): Record<string, string> => {
  return {
    ...existingHeaders,
    ...getLanguageHeaders()
  };
};

